import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import endpointList from '../../config/endpointList.jsx';
import AppConfig from '../../config/AppConfig.js';

// Async Thunk to Fetch Both APIs
export const fetchFonts = createAsyncThunk(
  'fonts/fetchFonts',
  async () => { 
    try {
      const [adminRes, googleRes] = await Promise.all([
        fetch(endpointList.getAdminfonts),
        fetch(endpointList.getGooglefonts),
      ]); 
      
      const adminFontsdata = await adminRes.json(); 
      // const adminFonts =  adminFontsdata.data || []; 
      const adminFonts = (adminFontsdata.data || []).map(f => ({
             family: f.font_family,                           
             src: `${AppConfig.storageUrl.replace(/\/$/, '')}/${f.regular_font.replace(/^\//, '')}` , 
             is_premium: f.is_premium === 1 ? 1 : 0,  
             source: 'admin',    
                    
           }));
      const googleData = await googleRes.json();
        const googleFonts = (googleData.items || []).map(f => ({
        family: f.family,
        src: f.files.woff2 || f.files.regular || null,  
        source: 'google',
      })).filter(f => f.src);
 
      // Combine both font lists
      const combinedFonts = [...adminFonts, ...googleFonts];
      console.log("combinefonts",combinedFonts)
      return combinedFonts;
      
    } catch (error) {
        console.log ("errorinfont",error)
      throw new Error(error.message);
    }
  }
);
  
const fontsSlice = createSlice({
  name: 'fonts',
  initialState: {
    fonts: [],
    status: 'idle',
    error: null,
    isLoaded: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFonts.pending, (state) => {
        state.status = 'loading';
        state.isLoaded = false;
      })
      .addCase(fetchFonts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.fonts = action.payload; 
        state.isLoaded = true;
      })
      .addCase(fetchFonts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.isLoaded = false;
      });
  },
});

export default fontsSlice.reducer;
